import React from 'react';
import './Reasons.css';
import image1 from '../../assets/image1.png';
import image2 from '../../assets/image2.png';
import image3 from '../../assets/image3.png';
import image4 from '../../assets/image4.png';
import nb from '../../assets/nb.png';
import nike from '../../assets/nike.png';
import adidas from '../../assets/adidas.png';
import tick from '../../assets/tick.png';

const Reasons = () => {
  return (
    <div className="Reasons" id="reasons">
        <div className="left-r">
            <img src={image1} alt="1" />
            <img src={image2} alt="2" />
            <img src={image3} alt="3" />
            <img src={image4} alt="4" />
        </div>

        <div className="right-r">
            <div>
                <span className='stroke-text'>Why </span>
                <span>Choose Us?</span>
            </div>

            <div className='details-r'>
                <div>
                    <img src={tick} alt="Tick" />
                    <span>OVER 140+ EXPERT COACHES</span>
                </div>
                <div>
                    <img src={tick} alt="Tick" />
                    <span>TRAIN SMARTER AND FASTER</span>
                </div>
                <div>
                    <img src={tick} alt="Tick" />
                    <span>1 FREE PROGRAM FOR NEW MEMBER</span>
                </div>
                <div>
                    <img src={tick} alt="Tick" />
                    <span>RELIABLE PARTNERS</span>
                </div>
            </div>

            <span 
                style={{
                    color: "var(--gray)",
                    fontWeight: "normal"
                }}
            >
                OUR PARTNERS
            </span>

            <div className="partners">
                <img src={nb} alt="nb" />
                <img src={adidas} alt="adidas" />
                <img src={nike} alt="nike" />
            </div>
        </div>
    </div>
  )
}

export default Reasons